import styled from '@emotion/styled';
import { IconElementProps } from 'framework/Icon/types';

export const IconElement = styled.div<IconElementProps>`
  height: ${({ height }) => height};
  min-width: ${({ width }) => width};
  width: ${({ width }) => width};
  font-size: ${({ size }) => size};
  color: ${({ theme }) => theme.normal};

  &:hover {
    color: ${({ theme }) => theme.hover};
  }
  &:focus {
    color: ${({ theme }) => theme.focus};
  }

  &[data-disabled='true'] {
    color: ${({ theme }) => theme.disabled};
    &:hover {
      color: ${({ theme }) => theme.disabled};
    }
    &:focus {
      color: ${({ theme }) => theme.disabled};
    }
  }

  &[data-button='true'] {
    cursor: pointer;
    color: inherit;
    &:hover {
      color: inherit;
    }
    &:focus {
      color: inherit;
    }
  }
`;
